module.exports = __webpack_public_path__ + "img/vino-app-icon.8d4dd281.svg";